import { Action, createReducer, on } from '@ngrx/store';
import { GroupsState, initialGroupsState } from '../states/groups.state';
import {
  currentGroupError,
  getGroupDetail,
  getGroupDetailSuccess,
  groupAction,
  groupListErrorAction,
  groupListLoadMoreAction,
  groupListLoadMoreSuccessAction,
  groupListSuccessAction,
  joinCurrentGroup,
  joinCurrentGroupSuccess,
  leaveCurrentGroup,
  leaveCurrentGroupSuccess
} from '../actions/group.action';

const reduce = createReducer(
  initialGroupsState,
  on(groupAction, state => ({
    ...state,
    groupList: {
      ...state.groupList,
      loading: true,
      error: '',
      groups: []
    }
  })),

  on(groupListLoadMoreAction, state => ({
    ...state,
    groupList: {
      ...state.groupList,
      loading: true,
      error: '',
      groups: []
    }
  })),

  on(groupListSuccessAction, (state, { payload }) => ({
    ...state,
    groupList: {
      ...state.groupList,
      loading: false,
      pageInfo: payload?.pageInfo,
      groups: payload?.data || []
    }
  })),

  on(groupListLoadMoreSuccessAction, (state, { payload }) => ({
    ...state,
    groupList: {
      ...state.groupList,
      loading: false,
      pageInfo: payload?.pageInfo,
      groups: state?.groupList?.groups.concat(payload?.data || [])
    }
  })),

  on(groupListErrorAction, (state, { error }) => ({
    ...state,
    groupList: {
      ...state.groupList,
      loading: false,
      error
    }
  })),
  on(getGroupDetail, state => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      group: null,
      loading: true,
      error: ''
    }
  })),

  on(getGroupDetailSuccess, (state, { payload }) => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: false,
      group: payload
    }
  })),
  on(currentGroupError, (state, { error }) => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: false,
      error
    }
  })),

  on(joinCurrentGroup, state => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: true
    }
  })),

  on(joinCurrentGroupSuccess, state => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: false,
      group: {
        ...state.currentGroup.group,
        membersCount: state.currentGroup.group.membersCount + 1,
        iamMember: true
      }
    }
  })),

  on(leaveCurrentGroup, state => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: true
    }
  })),

  on(leaveCurrentGroupSuccess, state => ({
    ...state,
    currentGroup: {
      ...state.currentGroup,
      loading: false,
      group: {
        ...state.currentGroup.group,
        membersCount: state.currentGroup.group.membersCount - 1,
        iamMember: false
      }
    }
  }))
);

export function GroupsReducer(
  state: GroupsState | undefined,
  action: Action
): GroupsState {
  return reduce(state, action);
}
